export default "__VITE_ASSET__CUK4K1m6__"